<template>
  <div class="bh-select">
    <p class="bh-select-label">{{ label }}</p>
    <v-select
      v-if="enableVuetifyOptions"
      v-bind="$attrs"
      v-on="$listeners"
      :placeholder="placeholder"
      :items="items"
      :value="value"
      :disabled="disabled"
      :label="selectLabel"
      flat
      dense
      :solo="solo"
      full-width
      :hide-details="hideDetails"
      :clearable="clearable"
      @change="$emit('input', $event)"
      @click:clear="$emit('clear')"
      :loading="loading"
      @click="$emit('click', $event)"
      :item-text="itemText"
      :item-value="itemValue"
      :background-color="backgroundColor"
      :append-icon="appendIcon"
    />
    <v-select
      v-else
      :placeholder="placeholder"
      :items="items"
      :value="value"
      :disabled="disabled"
      :label="selectLabel"
      flat
      dense
      :solo="solo"
      full-width
      :hide-details="hideDetails"
      :clearable="clearable"
      @change="$emit('input', $event)"
      @click:clear="$emit('clear')"
      :loading="loading"
      @click="$emit('click', $event)"
      :item-text="itemText"
      :item-value="itemValue"
      :background-color="backgroundColor"
      :append-icon="appendIcon"
    />
  </div>
</template>

<script>
export default {
  name: 'BhSelect',
  props: {
    enableVuetifyOptions: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: null,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    itemText: {
      type: String,
      default: 'text',
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean || 'auto',
      default: true,
    },
    backgroundColor: {
      type: String,
      default: undefined,
    },
    solo: {
      type: Boolean,
      default: false,
    },
    appendIcon: {
      type: String,
      default: 'mdi-menu-down',
    },
    selectLabel: {
      type: String,
      default: 'Choose',
    },
  },
}
</script>

<style lang="scss" scoped>
.bh-select {
  &-label {
    color: $bh-gray--2;
    cursor: default;
    font-weight: 700;
    font-size: 0.857rem;
    line-height: 1.6667;
    margin: 0;
  }
  .v-input__slot::before {
    border-color: rgba(0, 0, 0, 0.38);
  }
}
</style>
